<script>
import { Bar } from 'vue-chartjs'
import Tools from '@/tools/tools.js'

const brandBar  = '#20a8d8'
const brandMeta = '#f86c6b'

const normDay = v => {
  const d = new Date(v); return isNaN(d) ? null : d.toISOString().slice(0,10)
}
const keyMonth = v => (v ? v.slice(0,7) : '')
const fmtMesBR = (yyyyMM) => {
  if (!yyyyMM) return ''
  const [y,m] = yyyyMM.split('-')
  const d = new Date(Number(y), Number(m)-1, 1)
  return d.toLocaleDateString('pt-BR', { month: 'short', year: 'numeric' })
}
const fmtBRL = v => Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'})

export default {
  extends: Bar,
  name: 'GraficoBarrasVendasMensalVendedor',
  props: {
    dt1: { type: String, default: '' },
    dt2: { type: String, default: '' },
    vendedorId: { type: [String, Number], default: '' },
    metaMensal: { type: Number, default: 0 }
  },
  data () {
    return {
      busy: false,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: true, labels: { boxWidth: 12 } },
        tooltips: {
          mode: 'index', intersect: false,
          callbacks: {
            label: (ti, data) => {
              const dsLabel = (data.datasets[ti.datasetIndex]?.label) || ''
              return `${dsLabel}: ${fmtBRL(ti.yLabel)}`
            }
          }
        },
        scales: {
          xAxes: [{ gridLines: { display: false } }],
          yAxes: [{
            gridLines: { display: true },
            ticks: { beginAtZero: true, callback: v => fmtBRL(v) }
          }]
        },
        elements: { point: { radius: 0 } }
      },
      mesesOrdenados: []
    }
  },
  methods: {
    niceTop (v) {
      if (!isFinite(v) || v <= 0) return 10
      const p = Math.pow(10, Math.floor(Math.log10(v)))
      const n = Math.ceil(v / p)
      const step = [1,2,5,10].find(s => n <= s) || 10
      return step * p
    },

    renderGrafico (labels, valores, linhaMeta) {
      const datasets = [
        { type:'bar',  label:'Vendas (mês)', backgroundColor:'rgba(32,168,216,0.35)', borderColor:brandBar,  borderWidth:1.5, data: valores },
        { type:'line', label:'Meta mensal',  borderColor:brandMeta,  backgroundColor:'rgba(248,108,107,0.05)', borderWidth:2, fill:false, pointRadius:0, data: linhaMeta }
      ]

      const maxVal = Math.max(...valores.map(v=>Number(v||0)), Number(this.metaMensal||0), 10)
      const yMax = this.niceTop(maxVal)

      const options = {
        ...this.chartOptions,
        scales: {
          ...this.chartOptions.scales,
          yAxes: [{ ...this.chartOptions.scales.yAxes[0], ticks: { ...this.chartOptions.scales.yAxes[0].ticks, max: yMax } }]
        }
      }

      const data = { labels, datasets }

      if (this._chart) this._chart.destroy()
      this.$nextTick(() => this.renderChart(data, options))
    },

    async getDadosMensal () {
      this.$emit('busy', true)
      try {
        this.busy = true
        if (!this.vendedorId) {
          this.mesesOrdenados = []
          this.renderGrafico([], [], [])
          return
        }

        const { data: payload } = await this.$http.get('/api/protected/venda/getVendasPorDiaVendedorId', {
          params: { dt1: this.dt1, dt2: this.dt2, vendedorId: this.vendedorId }
        })
        const itens = Array.isArray(payload) ? payload : (payload?.data || [])

        const porMes = Object.create(null)
        for (const it of itens) {
          const diaIso = normDay(it.DT_SAIDA || it.dt_saida || it.dtSaida)
          if (!diaIso) continue
          const k = keyMonth(diaIso)
          const valor = Number(it.TOTAL_VENDAS ?? it.TOTAL_VENDAS ?? it.vlTotalNfe ?? it.total ?? 0)
          porMes[k] = (porMes[k] || 0) + valor
        }

        const meses = Object.keys(porMes).sort()
        this.mesesOrdenados = meses

        const labels = meses.map(fmtMesBR)
        const valores = meses.map(m => porMes[m] || 0)
        const linhaMeta = meses.map(() => Number(this.metaMensal || 0))

        this.renderGrafico(labels, valores, linhaMeta)
      } catch (e) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar as vendas mensais', 'danger', e)
      } finally {
        this.busy = false
        this.$emit('busy', false)
      }
    }
  },
  watch: {
    dt1: 'getDadosMensal',
    dt2: 'getDadosMensal',
    vendedorId: 'getDadosMensal',
    metaMensal: 'getDadosMensal'
  },
  async created () { await this.getDadosMensal() },
  beforeDestroy () { if (this._chart) this._chart.destroy() }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/GraficoBarrasVendasMensalVendedor.vue